// extracted by mini-css-extract-plugin
export default {"link":"hyperlink_link__Ey36S"};